import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Icon, Row, Col, Spin, Card, Tag, Select, Radio, Input, Button, Breadcrumb, Pagination } from 'antd'
import { Queries  } from '../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../components/user/Container'
import Search from '../../../components/user/Search'
import QualityDocumentDetail from '../../../components/user/QualityDocumentDetail'
import PolicyDocumentsDetail from '../../../components/user/PolicyDocumentsDetail'

//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import { changeFormatdate } from '../../../utils/formatdate'

const { Text, Title } = Typography
const InputGroup = Input.Group;

class Policy extends React.Component {

    state = {
        detailDocument: [],
        visibleModal: false,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false,
        listSystem: [],
        selectSearch: "search",
        selectSystem: null,
        searchForm:null,
        defaultValueSearch: null,
        preload: false,
        showDetail:"search",
        detailPolicy:null,
        dataFirstPage:true,
        checkUser:false,
        subTitle: "",
        offset: 0,
        limit: 10,
        total: 10,
        current:1
    }

    fetchListDocumen = async (search) => {
        const { client, location,match } = this.props
        const { selectMonth, selectYear, limit, offset } = this.state
        console.log('search',search)
        try {
            this.setState({
                preload:true
            })
            const { data, errors } = await client.query({
                query: Queries.fetchListDocumenList,
                variables: {
                    docGroupId: match.url.split('/')[3],
                    search,
                    offset,
                    limit
                }
            })
            //////////////////////addmodalINTERNAL_SERVER_ERROR
            // if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            //     await this.setState({
            //         showModalErrors: true
            //     })
            // }
            let dataDocument = []
            console.log(data.fetchListDocument)
            if(data.fetchListDocument.data.length !== 0){
                data.fetchListDocument.data.map((value, keys) =>{
                    dataDocument[keys] = {
                                            'id': value.docId,
                                            'title': value.docTitle,
                                            'activeDate': value.activeDate,
                                            'systemName' : value.systemName ? value.systemName : '',
                                            'updatedAt': value.updatedAt,
                                            'status': value.status
                                        }
                })
    
                await this.setState({
                    detailDocument: dataDocument,
                    preload: false,
                    showDetail:"search",
                    dataFirstPage:false,
                    total: data.fetchListDocument.total,
                })
            }else{
                await this.setState({
                    preload: false,
                    showDetail:"search",
                    dataFirstPage:false,
                    total: data.fetchListDocument.total,
                })
            }

        } catch (error) {
            console.log('error', error)
            // const errorMessage = error.graphQLErrors[0].message
            // message.error(errorMessage)
        }
      
    }

    checkStatus = (value) =>{
        if(value == 'PUBLIC'){
            return <>
                        <Icon type="global" className="mr-2" />
                        สาธารณะ
                    </>
        }else if(value == 'INTERNAL'){
            return  <>
                        <Icon type="team" className="mr-2" />
                        ภายใน
                    </>
        }else if(value == 'PRIVATE'){
            return 'ยังไม่เผยแพร่'
        }
    }

    onSearchData = (values) =>{
        this.fetchListDocumen(values)
    }

    fetchListSystem = async() =>{
        const { client } = this.props

        try {
            const { data, errors } = await client.query({
                query: Queries.fetchListSystem,
            })
            await this.setState({ listSystem: data.fetchListSystem});

        } catch (error) {
            console.log('error', error)
            // const errorMessage = error.graphQLErrors[0].message
            // message.error(errorMessage)
        }
    }

    onChangeSelectSearch = (e) =>{
        this.setState({
            selectSearch: e,
            selectSystem:null,
            detailDocument:[]
        })

        // this.fetchListDocumen(null)
    }

    onSearchInput = (e) =>{
        console.log(e.target.value)
        this.setState({
            defaultValueSearch: e.target.value
        })
        // this.fetchListDocumen(e.target.value)
    }

    onChangeSelectSystem = (e)=>{
        this.setState({
            selectSystem: e,
        })

        // this.fetchListDocumen(e)
    }

    onClickSearch = async () =>{
        const { defaultValueSearch, selectSearch, selectSystem } = this.state
        // console.log('selectSearch',selectSearch)
        await this.setState({
            detailDocument:[],
            preload:true,
            current:1,
            offset:0
        })
        if(selectSearch == 'search'){
            await this.fetchListDocumen(defaultValueSearch)
        }else{
            await this.fetchListDocumen(selectSystem)
        }
    }

    fetchListKCMHDocumentDetail = async (docId) => {
        const { client } = this.props
        const { data, errors } = await client.query({
            query: Queries.fetchListDocumen,
            variables: {
                docId
            }
        })

        //////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }
        // console.log(data.fetchListDocument[0])
        if(data.fetchListDocument.data[0]){
            await this.setState({
                detailPolicy: data.fetchListDocument.data[0],
                showDetail:"showData"
            })

            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        }else{
            await this.setState({
                detailPolicy: null,
                showDetail:"showData"
            })
        }
       
    }

    fetchProfile = async () => {
		try {
			const { client } = this.props
			const { data } = await client.query({
				query: Queries.fetchProfile
			})

			if(data.fetchProfile){
                console.log(data.fetchProfile.isKCMH)
                if(data.fetchProfile.isKCMH == 1){
                    await this.setState({ 
                        checkUser: true,
                        selectSearch: "system"
                    })
                }else{
                    await this.setState({ 
                        checkUser: false,
                        selectSearch: "search"
                    })
                }
			}
			
		} catch (e) {
			// message.error('Something went wrong. Please try again')
		}
	}

    async componentDidUpdate(prevProps, prevState) {
        // console.log(prevProps.match)x
        // if(prevProps.location.state.fetchKey !== this.props.location.state.fetchKey){
        if(prevProps.match.url.split('/')[3] !== this.props.match.url.split('/')[3]){
            await this.setState({
                defaultValueSearch: null,
                selectSystem: null,
                dataFirstPage:true,
                detailDocument:[],
                subTitle: this.props.location.state.subTitle,
                detailPolicy: null,
                preload:true,
                current:1,
                offset:0
            })

            await this.fetchListDocumen()
        }
    }

    onChangePagination = async page => {
        // console.log(page);
		const { limit } = this.state
        let offset = limit * (page - 1)
        
        await this.setState({
            offset,
            detailDocument:[],
            preload:true,
            current: page
        });

        await this.fetchListDocumen()
    };

    async componentDidMount() {
        const { match, location } = this.props

        // await this.fetchProfile()
        await this.fetchListDocumen()
        await this.fetchListSystem()
        if(location.state){
            this.setState({
                subTitle: location.state.subTitle
            })
        }
       
    }  

    render() {
        const { match, location } = this.props
        const { 
            detailDocument, 
            listSystem, 
            selectSearch, 
            selectSystem, 
            defaultValueSearch, 
            showDetail, 
            preload, 
            dataFirstPage, 
            detailPolicy, 
            checkUser, 
            subTitle,
            total,
            current
        } = this.state
        // console.log(location)
        return (
            <Container match={match}>
                <div className="breadcrumb-custom pb-3 mb-5">
                        <span style={{ fontSize:"18px" }}>ระเบียบ/หลักเกณฑ์ / { subTitle } </span>
                </div>
                
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    selectSearch &&
                    <div id="page-policy-hr">
                        <Row className="mb-4" gutter={16}>
                            <Col className="mb-2" span={24}>
                                <InputGroup compact>
                                    <Select defaultValue={ selectSearch } onChange={ this.onChangeSelectSearch } style={{ width:"20%" }}>
                                        {/* {
                                            checkUser &&
                                            <Select.Option value="system">ค้นหาด้วยระบบงาน</Select.Option>
                                        } */}
                                        <Select.Option value="search">ค้นหา</Select.Option>
                                    </Select>
                                    {
                                        // selectSearch == 'search'&&
                                            <Input.Search
                                                placeholder=""
                                                value={defaultValueSearch}
                                                onChange={ this.onSearchInput }
                                                style={{ width: "80%" }}
                                            />
                                        // ||
                                            // <Select  style={{ width: "80%" }} value={selectSystem} onChange={ this.onChangeSelectSystem }>
                                            //     <Select.Option  value={null}>ทั้งหมด</Select.Option>
                                            //     {
                                            //         listSystem.map((value,key) =>{
                                            //             return <Select.Option  value={value.id}>{value.name}</Select.Option>
                                            //         })
                                            //     }
                                            // </Select>
                                    }
                                </InputGroup>
                            </Col>
                            <Col className="mb-2" span={24} style={{ textAlign:"right" }}>
                                <Button 
                                    type="primary" 
                                    htmlType="submit" 
                                    className="color-white text-right fick-button-height-select" 
                                    onClick={ this.onClickSearch } 
                                >
                                    <Icon type="search" /> ค้นหา
                                </Button>
                            </Col>
                        </Row>
                        {
                            showDetail == 'search' &&
                                <>
                                    {
                                        detailDocument.length !== 0 &&
                                        <>
                                            {/* test */}
                                            <QualityDocumentDetail detailDocument={detailDocument} categoryName="Officer" fetchListKCMHDocumentDetail={this.fetchListKCMHDocumentDetail}/>
                                        </>
                                        ||
                                        preload &&
                                            <div style={{ textAlign: 'center', borderRadius: "10px", height: "130px" }}>
                                            <Icon type="loading" />
                                            </div>
                                        ||
                                        !dataFirstPage && 
                                        <div style={{ textAlign: 'center', borderRadius: "10px", height: "130px" }}>
                                            <Text className="color-gray" >ไม่พบข้อมูล</Text>
                                        </div>
                                    }

                                    {
                                        detailDocument.length !== 0 &&
                                            <Pagination current={current} onChange={this.onChangePagination} total={total}/>
                                    }
                                </>
                            ||
                            detailPolicy &&
                                <PolicyDocumentsDetail detailPolicy={detailPolicy}/>
                            ||
                            <div style={{ textAlign: 'center', borderRadius: "10px", height: "130px" }}>
                                <Text className="color-gray" >ไม่พบข้อมูล</Text>
                            </div>
                        }
                    </div>
                }
            </Container>
        )
    }
}

Policy.propTypes = {
    //
}

export default withApollo(Policy)